import { render } from "./tender_time.vue?vue&type=template&id=216f54e2&scoped=true"
import script from "./tender_time.vue?vue&type=script&lang=js"
export * from "./tender_time.vue?vue&type=script&lang=js"

import "./tender_time.vue?vue&type=style&index=0&id=216f54e2&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216f54e2"],['__file',"vue/js/components/contragent/tender/tabs/tender_time.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "216f54e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('216f54e2', __exports__)) {
    console.log('reload')
    api.reload('216f54e2', __exports__)
  }
  
  module.hot.accept("./tender_time.vue?vue&type=template&id=216f54e2&scoped=true", () => {
    console.log('re-render')
    api.rerender('216f54e2', render)
  })

}


export default __exports__